import React from 'react';
import PropTypes from 'prop-types';

import {
  Experiment,
  ExperimentControl,
  ExperimentVariant,
} from '@nerdwallet/features';

import { VERTICALS } from '../lib/front-page-content-src/constants';

import verticalComparisonContent from '../lib/front-page-content-src/verticalComparisonContent';
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';

const TEST_NAME = 'reg-1686-homepage-banking-tab-order_experiment';
const VARIANT = 'variant';

const VARIANT_TABS = [
  VERTICALS.CREDIT_CARD,
  VERTICALS.BANKING,
  VERTICALS.TRAVEL,
  VERTICALS.SMALL_BUSINESS,
  VERTICALS.PERSONAL_LOANS,
  VERTICALS.MORTGAGES,
  VERTICALS.INSURANCE,
  VERTICALS.INVESTING,
  VERTICALS.STUDENT_LOANS,
];

const BankingTabOrderExperiment = ({ children }) => {
  return (
    <Experiment testName={TEST_NAME}>
      <ExperimentControl>{children}</ExperimentControl>
      <ExperimentVariant name={VARIANT}>
        <VerticalComparison
          title={verticalComparisonContent.title}
          backgroundImageUrl={verticalComparisonContent.backgroundImageUrl}
          tabs={VARIANT_TABS}
        />
      </ExperimentVariant>
    </Experiment>
  );
};

BankingTabOrderExperiment.propTypes = {
  children: PropTypes.node,
};

export default BankingTabOrderExperiment;
